<template>
  <ion-page id="passwordreset-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
           :style="styleOneFrame" :key="menuTrigger">
        <div v-if="hasError" >
          <ion-item color="warning">
            {{ message }}
          </ion-item>
        </div>
        <div v-else>
          <ion-item>
            {{ message }}
          </ion-item>
        </div>
        <div v-if="showForm">
          <ion-item>
            {{ t("For Email") }}: {{ email }}
          </ion-item>
          <ion-item>
            <ion-input :label="passwordString" type="password" label-placement="fixed" 
                    :placeholder="enterPasswordString" :value="password"
                    @ionInput="passwordInputChange">
              <ion-input-password-toggle slot="end"></ion-input-password-toggle>
            </ion-input>
          </ion-item>
          <ion-item>
            <ion-input :label="passwordString" type="password" label-placement="fixed" 
                    :placeholder="enterPasswordString" :value="password2"
                    @ionInput="password2InputChange">
              <ion-input-password-toggle slot="end"></ion-input-password-toggle>

            </ion-input>
          </ion-item>

          <ion-item>
            <ion-checkbox label-placement="end" @ionChange="resetCookie = !resetCookie" checked>
              <span class="ion-text-wrap">{{ t("Cancel any open sessions on other devices.<br><em>(Not needed if you only forgot your password)</em>") }}</span>
              
            </ion-checkbox>
          </ion-item>
          <ion-item>
            <ion-button expand="block" size="large" @click="doReset()" >{{ t("Reset Password") }}</ion-button>
          </ion-item>        
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

// https://stackoverflow.com/questions/35914069/how-can-i-get-query-parameters-from-a-url-in-vue-js

import { IonLabel,IonCheckbox, IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, 
        IonInputPasswordToggle, IonContent , modalController } from '@ionic/vue';

import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
import { t } from '@/composables/translateText.js'

import { ref , watch } from 'vue'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { useGetData } from '@/composables/getData.js'
import { availableWidthHeight }  from '@/composables/screenSize'

const connectionStore = useConnectionStore()
  
const isDark = ref(connectionStore.getDarkmode != "light")
const menuTrigger = ref(0)

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

const urlParams =  new URLSearchParams(window.location.search)

const passwordString = ref(t("Password"))
const enterPasswordString = ref(t("Enter password"))

const hasError = ref(false)
const message = ref("")
const verify = ref("")
const email = ref("")

const password = ref("")
const password2 = ref("")
const resetCookie = ref(false)

const showForm = ref(true)

var url_v = localStorage.getItem("url_v")
var url_e = localStorage.getItem("url_e")

if (url_v == null || url_e == null) {
  hasError.value = true
  message.value = "The necessary URL parameters aren't there. If this persists, please contact support@chessvis.com"
}
else {
  hasError.value = false
  verify.value = url_v
  email.value = decodeURIComponent(url_e)

}

const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })
 
updateWidthHeights()

function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"

  //console.log("frame size",styleOneFrame.value)
}

const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** Explorer -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Explorer new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })

  function passwordInputChange(ev) {
    //console.log("password ",ev)
    const value = ev.target.value;
    //console.log("password",value)
    password.value = value.trim()
  }


  function password2InputChange(ev) {
    //console.log("password2 ",ev)
    const value = ev.target.value;
    //console.log("password2",value)
    password2.value = value.trim()
  }

function processJsonResponse (json) {
  //console.log(" in callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }
  switch (json['stat']) {
    case 'g' :
      message.value = t("Password Reset. Please use the 'Signin' screen with the new password.")
      showForm.value = false
      hasError.value = false
      break
    default :
      message.value = json['stat']
      hasError.value = true
      break;
  }
}

function doReset() {
  if (password.value == "") {
    message.value = t("Please enter your password")
    return
  }
  if (password2.value != password.value) {
    message.value = t("Passwords don't match")
    return
  }
  message.value = t("resetting password") + "...."
  var formData = { 
    e : email.value , 
    v : verify.value, 
    p: password.value,
    reset_cookie : (resetCookie.value) ? "y" : "n"
  }
  //console.log("password reset formdata",formData)
  useGetData("process9_password_reset.php", formData, processJsonResponse)
}



</script>

<style scoped>

.item{
  margin:10px auto;
}

</style>
